import { render, staticRenderFns } from "./UpdateExpirationDate.vue?vue&type=template&id=096eb4fc&"
import script from "./UpdateExpirationDate.vue?vue&type=script&lang=js&"
export * from "./UpdateExpirationDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports